import React from "react";
import PropTypes from "prop-types";
import { formatShortDate } from "lib/format";

export default class ShortDate extends React.Component {
  
  static propTypes = {
    date: PropTypes.string.isRequired
  }
  
  render() {
    return formatShortDate(this.props.date);
  }
  
}



// WEBPACK FOOTER //
// ./src/components/ShortDate.js